import React, {useEffect, useState} from 'react';
import Tooltip from '@components/tooltip';
import styles from './styles.module.scss';
import {classes} from 'as-ui-kit/utils/styles';
import nanoid from 'ati-utils/nanoid';
import PropTypes from 'prop-types';

const Ellipsis = ({placement, tooltipClassnames, className= '', children, tooltipText}) => {
    const [isTooltipVisible, setTooltipVisible] = useState(true);

    const id = nanoid();

    const copiedChildren = React.cloneElement(children, {
        id: 'text',
        className: classes(styles['ellipsis'], className)
    });

    const textContainer = (
        <div
            className={styles['container']}
            id={id}
        >
	        {copiedChildren}
        </div>
    );

    useEffect(() => {
        const container = document.getElementById(id);
        const text = container?.children?.namedItem('text');

        if (container?.offsetWidth < text?.scrollWidth) setTooltipVisible(true);
        else setTooltipVisible(false);
    }, [id, children]);

    return isTooltipVisible ? (
        <Tooltip
            classNames={tooltipClassnames}
            content={isTooltipVisible ? tooltipText : null }
            placement={placement || 'top'}
        >
            {textContainer}
        </Tooltip>
    ) : textContainer;
};

Ellipsis.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    placement: PropTypes.string,
    tooltipClassnames: PropTypes.string,
    tooltipText: PropTypes.string.isRequired,
};

export default Ellipsis;
